import { Component, OnInit, Optional, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { UtilService } from 'src/app/util/util.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CROSS } from 'src/defaultImages.js';
@Component({
  selector: 'app-void-dish',
  templateUrl: './void-dish.component.html',
  styleUrls: ['./void-dish.component.css'],
})
export class VoidDishComponent implements OnInit, OnDestroy {
  images = {
    CROSS: CROSS,
  };
  itemDetail: any;
  currentCount: number;
  orderId: string;
  adminPin: string;
  /* Set only for GrabFood orders: { orderID, restaurant_id }. See voidDish(). */
  grabOrder: any;
  selectedOption: string;
  reason_text: string;
  translationText;
  btnDisabled: boolean = false;
  reasons = [
    { id: 'dish out of stock', name: 'Dish Out Of Stock' },
    { id: 'variant out Of stock', name: 'Variant Out Of Stock' },
    { id: 'add on out of stock', name: 'Add On Out Of Stock' },
  ];
  subscription = new Subscription();
  constructor(
    public dialogRef: MatDialogRef<VoidDishComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private utilService: UtilService,
    private message: MessageService,
    public translateService: TranslateService
  ) {
  }

  ngOnInit() {
    this.subscription.add(
      this.translateService.get(['VOID_DISH']).subscribe((translation) => {
        this.translationText = translation.VOID_DISH;
        this.reasons = [
          { id: this.translationText.DISH_OUT_OF_STOCK, name: this.translationText.DISH_OUT_OF_STOCK },
          { id: this.translationText.VARIANT_OUT_OF_STOCK, name: this.translationText.VARIANT_OUT_OF_STOCK },
          { id: this.translationText.ADD_ON_OUT_OF_STOCK, name: this.translationText.ADD_ON_OUT_OF_STOCK },
        ];
      }));
    this.itemDetail = this.data.itemDetails;
    this.orderId = this.data.orderid;
    this.adminPin = this.data.adminPin;
    this.grabOrder = this.data.grabOrder;
    this.currentCount = 1;
    this.setRadio(this.reasons && this.reasons[0] ? this.reasons[0].id : null);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  addToCart(operator) {
    this.currentCount = this.currentCount + operator;
  }

  voidDish() {
    this.btnDisabled = true;
    let decline_reason = this.selectedOption;
    if (this.selectedOption == 'custom') {
      if (
        this.reason_text == '' ||
        this.reason_text == null ||
        this.reason_text == undefined
      ) {
        this.message.info(this.translationText.ENTER_REASON_FOR_VOIDING_DISH);
        this.btnDisabled = false;
        return;
      }
      decline_reason = this.reason_text;
    }

    /*
     * A GrabFood order has to be edited AT GRAB, not just voided here — voidDish() only
     * touches our copy, which would leave Grab still expecting the dish. The nest endpoint
     * sends the edit to Grab first and voids our copy only once Grab accepts, so both
     * calls land on the same PHP void in the end and the handling below is shared.
     */
    const request = this.grabOrder
      ? this.apiService.grabApplyEdit({
          restaurant_id: this.grabOrder.restaurant_id,
          orderID: this.grabOrder.orderID,
          void_items: [
            {
              order_item_id: this.itemDetail.order_item_id,
              qty: this.currentCount,
              decline_reason: decline_reason,
            },
          ],
        })
      : this.apiService.voidDish(this.buildVoidFormData(decline_reason));

    request.subscribe(
      (res: any) => {
        try {
          if (res.status === 1) {
            this.dialogRef.close({ data: 'refresh' });
            /* Grab applied the edit but our copy did not move — the dish is gone at Grab
               and still on this screen, so say so instead of a plain success. */
            if (res.local_applied === false) {
              this.message.showError(
                'Updated at Grab, but this order may be stale — please refresh'
              );
            } else {
              this.message.showSuccess(this.translationText.DISH_UPDATED);
            }
            this.utilService.sendVoidCommand(
              this.orderId,
              this.itemDetail.item_id,
              this.itemDetail.order_item_id,
              this.currentCount
            );
            this.btnDisabled = false;
          } else {
            this.dialogRef.close({ data: 'refresh' });
            this.message.showError(res.message);
            this.btnDisabled = false;
          }
        } catch (error) {
          this.dialogRef.close({ data: 'refresh' });

          this.message.showError(this.translationText.DISH_VOID_FAILED);
          this.btnDisabled = false;
        }
      },
      () => {
        this.dialogRef.close({ data: 'refresh' });
        this.message.showError(this.translationText.DISH_VOID_FAILED);
        this.btnDisabled = false;
      }
    );
  }

  private buildVoidFormData(decline_reason: string): any {
    const formData: any = new FormData();
    formData.append('token', localStorage.getItem('token'));
    formData.append('order_item_id', this.itemDetail.order_item_id);
    formData.append('order_id', this.orderId);
    formData.append('qty', this.currentCount);
    formData.append('decline_reason', decline_reason);
    if (this.adminPin) {
      formData.append('admin_pin', this.adminPin);
    }
    return formData;
  }

  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }
  radioChanged(e) {}
  setRadio(id) {
    this.selectedOption = id;
  }

  validateInput(event){
    const allowedKeys = ['Backspace', 'Enter', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];
    const isNumber = /^[0-9]$/.test(event?.key);
    const isAllowedKey = allowedKeys.includes(event?.key);
    
    if (!isNumber && !isAllowedKey) {
      event.preventDefault();
      return false;
    }
    if (isNumber) {
      const currentValue = event?.target?.value || '';
      const newValue = currentValue + event?.key;
      const maxQuantity = this.itemDetail?.item_quantity;
      
      if (parseInt(newValue) > maxQuantity) {
        this.currentCount = maxQuantity;
        event.preventDefault();
        return false;
      }
    }
  }
}
